import { render, staticRenderFns } from "./VerificationChecklist.vue?vue&type=template&id=3e67f1b4"
import script from "./VerificationChecklist.vue?vue&type=script&lang=js"
export * from "./VerificationChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports